import { BizData } from '../data';
import { Util } from '../util';
import { View } from '../view';

/** 氚云统一结构化过滤器 */
export namespace Filter {
    /** 比较操作符 */
    export enum Operator {
        /** 等于 */
        Equal = 'Equal',
        /** 不等于 */
        NotEqual = 'NotEqual',
        /** 包含 */
        Contains = 'Contains',
        /** 不包含 */
        NotContains = 'NotContains',
        /** 被包含于 */
        Contained = 'Contained',
        /** 不被包含于 */
        NotContained = 'NotContained',
        /** 为空 */
        IsBlank = 'IsBlank',
        /** 不为空 */
        NotBlank = 'NotBlank',
        /** 等于任意一个 */
        In = 'In',
        /** 不等于任意一个 */
        NotIn = 'NotIn',
        /** 在范围内 */
        Between = 'Between',
        /** 小于等于 */
        NotAbove = 'NotAbove',
        /** 大于等于 */
        NotBelow = 'NotBelow',
        /** 大于 */
        Above = 'Above',
        /** 小于 */
        Below = 'Below',
        /** 动态范围 */
        Dynamic = 'Dynamic',
    }

    /** 氚云统一结构化过滤器转筛选操作比较符 */
    export const FilterOperatorToComparisonOperatorType = {
        [Operator.Equal]: BizData.Filter.ComparisonOperatorType.Equal,
        [Operator.NotEqual]: BizData.Filter.ComparisonOperatorType.NotEqual,
        [Operator.Contains]: BizData.Filter.ComparisonOperatorType.Contains,
        [Operator.NotContains]: BizData.Filter.ComparisonOperatorType.NotContains,
        [Operator.IsBlank]: BizData.Filter.ComparisonOperatorType.IsNone,
        [Operator.NotBlank]: BizData.Filter.ComparisonOperatorType.NotNone,
        [Operator.In]: BizData.Filter.ComparisonOperatorType.In,
        [Operator.NotIn]: BizData.Filter.ComparisonOperatorType.NotIn,
        [Operator.Between]: BizData.Filter.ComparisonOperatorType.Between,
        [Operator.NotAbove]: BizData.Filter.ComparisonOperatorType.NotAbove,
        [Operator.NotBelow]: BizData.Filter.ComparisonOperatorType.NotBelow,
        [Operator.Above]: BizData.Filter.ComparisonOperatorType.Above,
        [Operator.Below]: BizData.Filter.ComparisonOperatorType.Below,
    };

    /** 筛选操作比较符转氚云统一结构化过滤器 */
    export const ComparisonOperatorToFilterOperatorType = {
        [BizData.Filter.ComparisonOperatorType.Equal]: Operator.Equal,
        [BizData.Filter.ComparisonOperatorType.NotEqual]: Operator.NotEqual,
        [BizData.Filter.ComparisonOperatorType.Contains]: Operator.Contains,
        [BizData.Filter.ComparisonOperatorType.NotContains]: Operator.NotContains,
        [BizData.Filter.ComparisonOperatorType.IsNone]: Operator.IsBlank,
        [BizData.Filter.ComparisonOperatorType.NotNone]: Operator.NotBlank,
        [BizData.Filter.ComparisonOperatorType.In]: Operator.In,
        [BizData.Filter.ComparisonOperatorType.NotIn]: Operator.NotIn,
        [BizData.Filter.ComparisonOperatorType.Between]: Operator.Between,
        [BizData.Filter.ComparisonOperatorType.NotAbove]: Operator.NotAbove,
        [BizData.Filter.ComparisonOperatorType.NotBelow]: Operator.NotBelow,
        [BizData.Filter.ComparisonOperatorType.Above]: Operator.Above,
        [BizData.Filter.ComparisonOperatorType.Below]: Operator.Below,
    };

    /**氚云统一结构化过滤器转统计分析操作比较符 */
    export const FilterOperatorToComparisonFormula = {
        [Operator.Equal]: View.ComparisonFormula.Equal,
        [Operator.NotEqual]: View.ComparisonFormula.NotEqual,
        [Operator.Contains]: View.ComparisonFormula.Match,
        [Operator.NotContains]: View.ComparisonFormula.NotMatch,
        [Operator.IsBlank]: View.ComparisonFormula.None,
        [Operator.NotBlank]: View.ComparisonFormula.NotNone,
        [Operator.In]: View.ComparisonFormula.In,
        [Operator.NotIn]: View.ComparisonFormula.NotIn,
        [Operator.Between]: View.ComparisonFormula.Range,
        [Operator.NotAbove]: View.ComparisonFormula.NotAbove,
        [Operator.NotBelow]: View.ComparisonFormula.NotBelow,
        [Operator.Above]: View.ComparisonFormula.Above,
        [Operator.Below]: View.ComparisonFormula.Below,
    };

    // 日期类型字段子比较符类型
    export enum SubOperator {
        YMDHMS = 'yyyy-MM-dd HH:mm:ss', // 年月日时分秒
        YMDHM = 'yyyy-MM-dd HH:mm', // 年月日时分
        YMD = 'yyyy-MM-dd', // 年月日
        YM = 'yyyy-MM', // 年月
    }

    /** 比较操作符文本映射，暂时先实现部分 */
    export const OperatorTextMap = {
        [Filter.Operator.Equal]: '等于',
        [Filter.Operator.NotEqual]: '不等于',
        [Filter.Operator.Contains]: '包含',
        [Filter.Operator.NotContains]: '不包含',
        [Filter.Operator.Contained]: '被包含于',
        [Filter.Operator.NotContained]: '不被包含于',
        [Filter.Operator.IsBlank]: '为空',
        [Filter.Operator.NotBlank]: '不为空',
        [Filter.Operator.In]: '等于任意一个',
        [Filter.Operator.NotIn]: '不等于任意一个',
        [Filter.Operator.Between]: '在范围内',
        [Filter.Operator.NotAbove]: '小于等于',
        [Filter.Operator.NotBelow]: '大于等于',
        [Filter.Operator.Above]: '大于',
        [Filter.Operator.Below]: '小于',
        [Filter.Operator.Dynamic]: '动态范围',
    };

    /** 操作符对应图标 */
    export const OperatorIconMap = {
        [Filter.Operator.Equal]: 'operator-equal',
        [Filter.Operator.NotEqual]: 'operator-not-equal',
        [Filter.Operator.Contains]: 'operator-contains',
        [Filter.Operator.NotContains]: 'operator-not-contains',
        [Filter.Operator.IsBlank]: 'operator-is-blank',
        [Filter.Operator.NotBlank]: 'operator-not-blank',
        [Filter.Operator.In]: 'operator-in',
        [Filter.Operator.NotIn]: 'operator-not-in',
        [Filter.Operator.Between]: 'operator-between',
        [Filter.Operator.NotAbove]: 'operator-not-above',
        [Filter.Operator.NotBelow]: 'operator-not-below',
        [Filter.Operator.Above]: 'bevel-right-stroke',
        [Filter.Operator.Below]: 'bevel-left-stroke',
        [Filter.Operator.Dynamic]: 'writing-fluently-stoke',
    };

    // 日期类型字段子比较符类型名称映射
    export const SubOperatorTextMap = {
        [Filter.SubOperator.YMDHMS]: '年月日时分秒',
        [Filter.SubOperator.YMDHM]: '年月日时分',
        [Filter.SubOperator.YMD]: '年月日',
        [Filter.SubOperator.YM]: '年月',
    };

    // 支持子比较符的操作符
    export const SupportSubOperatorOperators = [
        Filter.Operator.Equal,
        Filter.Operator.NotEqual,
        Filter.Operator.Between,
        Filter.Operator.Above,
        Filter.Operator.Below,
        Filter.Operator.NotAbove,
        Filter.Operator.NotBelow,
        Filter.Operator.Above,
        Filter.Operator.Below,
    ];

    /** 值类型 */
    export enum ValueType {
        /** 自定义 */
        Fixed = 'Fixed',
        /** 字段 */
        PropertyName = 'PropertyName',
        /** 公式计算 */
        Expression = 'Expression',
        /** 自定义 */
        Custom = 'Custom',
        /** 动态 */
        Dynamic = 'Dynamic',
        /** 自动化 */
        CustomParameter = 'CustomParameter',
    }

    /** 筛选使用场景类型 */
    export enum SceneType {
        ListButtonValidate = 'listButtonValidate',
        /** 关联汇总的通用场景 */
        Rollup = 'rollup',
        /** 仅支持固定值的通用场景 */
        OnlyFixed = 'fixed',
        /** 视图筛选 */
        ViewFilter = 'viewFilter',
        /** 关联多选填充规则(表单设计器) */
        MultiQueryMapping = 'multiQueryMapping',
    }

    /** 筛选项 */
    export interface IFilterItem<T = any> {
        PropertyName: string;
        Operator: Operator;
        SubOperator?: SubOperator; // 日期类型字段子比较符类型,时分格式不支持
        ValueType: ValueType;
        Value: T;
        Id?: string;
    }

    /** 输入范围限定公式 */
    export interface ILowerCaseFilterItem<T = any> {
        propertyName: string;
        operator: Operator;
        valueType: ValueType;
        value: T;
        id?: string;
    }

    /** 填充规则 */
    export namespace Mapping {
        /** 填充类型 */
        export const enum MappingValueSetType {
            /** 设为 */
            Set = 1,
            /** 追加 */
            Append = 2,
            /** 清空 */
            Clear = 3,
            /** 删除 */
            Remove = 4,
        }

        /** 匹配类型 */
        export enum MappingValueType {
            /** 固定值 */
            Fixed = 1,
            /** 字段 */
            PropertyName = 2,
            /** 公式 */
            Expression = 3,
            /** 自定义参数 */
            CustomParameter = 4,
            /** 字段最大值 */
            PropertyNameMax = 100,
            /** 字段最小值 */
            PropertyNameMin = 101,
            /** 字段求和 */
            PropertyNameSum = 102,
            /** 字段去重求和(复选框、人员部门多选等多选场景) */
            PropertyNameSumDistinct = 103,
            /** 字段分割成元素 */
            PropertyNameSplitArrayIntoElements = 104,
            /** 关联外链 */
            LinkExternalFormLink = 105,
            /** 关联数据分享 */
            LinkDataSharingLink = 106,
            /** 关联公开查询 */
            LinkPublicQueryLink = 107,
            /** 字段相同值置为空 */
            PropertyNameSetEmptyIfAllsSame = 108,
        }

        export type MappingProperty = {
            /** 表单编码 */
            SchemaCode: string;
            /** 当前表单字段 */
            PropertyName: string;
            /** 填充类型 */
            ValueSetType: MappingValueSetType;
            /** 匹配类型 */
            ValueType: MappingValueType;
            /** 值 */
            Value: unknown;
            /** 扩展信息 */
            Extension?: {
                /** 关联属性编码 */
                AssociationPropertyName: string;
                LinkInfo?: {
                    SchemaCode: string;
                    PropertyMappings: MappingProperty[];
                    ParametersEnable: boolean;
                };
            };
        };

        type MappingSetting = {
            /** 目标表单的表单编码 */
            TargetSchemaCode: string;
            /** 源表单的表单编码 */
            SourceSchemaCode: string;
            /** 筛选条件 */
            SourceCondition?: Util.JSONStringify<IFilterItem[][]>;
            /** 属性映射 */
            PropertyMappings: MappingProperty[];
            /** 是否分组 */
            GroupBy: boolean;
        };

        /** 填充规则 */
        export type MappingSettings = {
            /** 主表 */
            Main?: MappingSetting | null;
            /** 子表 */
            Children?: MappingSetting[];
        };

        /** 小驼峰形式，原因是有些接口后端会默认转一道 */
        export namespace LowerCase {
            export type MappingProperty = {
                /** 表单编码 */
                schemaCode: string;
                /** 当前表单字段 */
                propertyName: string;
                /** 填充类型 */
                valueSetType: MappingValueSetType;
                /** 匹配类型 */
                valueType: MappingValueType;
                /** 值 */
                value: unknown;
                /** 扩展信息 */
                extension?: {
                    /** 关联属性编码 */
                    associationPropertyName: string;
                    linkInfo?: {
                        schemaCode: string;
                        propertyMappings: MappingProperty[];
                        parametersEnable: boolean;
                    };
                };
            };

            export type MappingSetting = {
                /** 目标表单的表单编码 */
                targetSchemaCode: string;
                /** 源表单的主表编码 */
                sourceSchemaCode: string;
                /** 筛选条件 */
                sourceCondition?: Util.JSONStringify<IFilterItem[][]>;
                /** 属性映射 */
                propertyMappings: MappingProperty[];
                /** 是否分组 */
                groupBy: boolean;
            };

            /** 填充规则 */
            export type MappingSettings = {
                /** 主表 */
                main?: MappingSetting;
                /** 子表 */
                children?: MappingSetting[];
            };
        }
    }
}
